import { MAP_TYPES } from '@deck.gl/carto';
 
const HARD_BRAKING_SOURCE_ID = 'hardBrakingSource';
 
const source = {
  id: HARD_BRAKING_SOURCE_ID,
  type: MAP_TYPES.QUERY,
  connection: 'cartointegration',
  data: 'hard_braking_event_source',
};
 
export default source;
 